import { createAsyncThunk } from "@reduxjs/toolkit";
import { liveUsageMgmtProviderSelector } from "../../../selectors/store-selectors/liveUsageMgmtProviderSelector";
import { resourceTypesByProvider } from "@/utils/helpers/providers/resourceTypesByProvider";
import { RootState } from "@/store/store";
import { getLiveUsageResourceMetadataThunk } from "@/store/live-usage-mgmt/thunks/resources/resource-metadata/getLiveUsageResourceMetadataThunk";

export const getLiveUsageAllResourcesMetadataThunk = createAsyncThunk(
  "liveUsageMgmt/getLiveUsageAllResourcesMetadata",
  async (_: void, { dispatch, getState }) => {
    const state = getState() as RootState;
    const provider = liveUsageMgmtProviderSelector(state);

    if (!provider) {
      return;
    }

    const resourceTypes = resourceTypesByProvider(provider);

    resourceTypes?.forEach((resourceType) => {
      dispatch(getLiveUsageResourceMetadataThunk(resourceType)).unwrap();
    });
  },
);
